import { createSelector } from 'reselect';
import configs from '../configs';

const { maxMerchantsToShow } = configs;

export const selectPickFavorites = state => state.pickFavorites;
export const selectPickFavoritesConfig =
  createSelector(selectPickFavorites, pickFavorites => pickFavorites.config);
export const selectPickFavoritesIsLoading =
  createSelector(selectPickFavorites, pickFavorites => pickFavorites.isLoading);
export const selectPickFavoritesIsLoaded =
  createSelector(selectPickFavorites, pickFavorites => pickFavorites.isLoaded);
export const selectPickFavoritesRecords =
  createSelector(selectPickFavorites, pickFavorites => pickFavorites.merchants);
export const selectPickFavoritesMerchantsQueue =
  createSelector(selectPickFavorites, pickFavorites => pickFavorites.pickFavoriteMerchantsQueue);
export const selectPickFavoritesMerchantsQueueToShow =
  createSelector(selectPickFavoritesMerchantsQueue, pickFavoritesMerchantsQueue =>
    pickFavoritesMerchantsQueue.slice(0, maxMerchantsToShow));
